var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-link',{staticClass:"mr-1",attrs:{"type":"info","loading":_vm.isLoading},on:{"click":_vm.downloadFile}},[_vm._v(" "+_vm._s(_vm.attachment.path)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }